import React from "react";
import { Box, Typography, Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip, tooltipClasses } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import { styled } from "@mui/styles";
import { Upload } from "antd";
import { iconMap } from "./categoryIcons";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const IconPickerDialog = ({ openIconDialog, handleCloseIconDialog, handleCustomUpload, selectedIcon, handleIconSelect, handleSaveIcon }) => (
<>
      {/* Dialog for selecting icons */}
      <Dialog
        sx={{
          "& .MuiDialog-container .MuiPaper-elevation": {
            borderRadius: "8px",
            width: "650px",
            maxWidth: "650px",
          },
        }}
        open={openIconDialog}
        onClose={handleCloseIconDialog}
      >
        <DialogTitle
          sx={{
            padding: "20px 16px 15px",
            textAlign: "center",
            fontWeight: 700,
          }}
        >
          Select Icon
        </DialogTitle>
        <DialogContent
          sx={{ padding: "0 16px", height: "calc(100vh - 400px)" }}
        >
          <Box
            display={"flex"}
            justifyContent={"center"}
            marginBottom={"10px"}
            flexDirection={"column"}
            alignItems={"center"}
          >
            <Upload
              showUploadList={false}
              customRequest={handleCustomUpload}
              accept=".svg"
            >
              <LightTooltip title="*Only svgs allowed" placement="top">
                <Button
                  variant="contained"
                  startIcon={<UploadIcon />}
                  sx={{
                    flexShrink: 0,
                    width: "170px",
                    // margin: '8px 0 0',
                    backgroundColor: "#142C5C",
                    color: "#fff",
                    borderColor: "#0f2247",
                    "&:hover": {
                      backgroundColor: "#0f2247",
                    },
                    borderRadius: "6px",
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "13px",
                      lg: "14px",
                      xl: "14px",
                    },
                    height: "53px",
                  }}
                >
                  Custom Upload
                </Button>
              </LightTooltip>
            </Upload>
          </Box>
          <Box display="grid" gridTemplateColumns="repeat(6, 1fr)" gap={1}>
            {Object.keys(iconMap).map((iconName) => {
              const IconComponent = iconMap[iconName];
              return (
                <Box
                  key={iconName}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  onClick={() => handleIconSelect(iconName)}
                  sx={{
                    cursor: "pointer",
                    padding: "10px 0",
                    border: "2px solid",
                    borderColor:
                      selectedIcon === iconName ? "#142C5C" : "transparent",
                    borderRadius: 1,
                    textAlign: "center",
                    transition: "border-color 0.3s ease",
                    backgroundColor:
                      selectedIcon === iconName ? "#142C5C" : "transparent",
                  }}
                >
                  <IconComponent
                    color={selectedIcon === iconName ? "#fff" : "#555"}
                    size={20}
                  />
                  <Typography
                    variant="caption"
                    mt={0.5}
                    fontSize="10px"
                    fontWeight="600"
                    color={selectedIcon === iconName ? "#fff" : "#555"}
                  >
                    {iconName}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: "10px 16px 20px" }}>
          <Button
            onClick={handleCloseIconDialog}
            sx={{
              border: "1px solid #888",
              color: "#888",
              borderRadius: "6px",
              fontSize: "14px",
              "&:hover": {
                backgroundColor: "#b9b9b9",
                color: "#222",
                borderColor: "#b9b9b9",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveIcon}
            sx={{
              backgroundColor: "#142C5C",
              color: "#fff",
              borderColor: "#0f2247",
              "&:hover": {
                backgroundColor: "#0f2247",
              },
              borderRadius: "6px",
              fontSize: {
                xs: "12px",
                sm: "13px",
                md: "13px",
                lg: "14px",
                xl: "14px",
              },
              height: "40px",
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
</>
);

export default IconPickerDialog;
